import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { BulkEditActions } from './bulk-edit.actions';
import { BulkOperationType, Survey } from '@ps/survey-utils';
import { SurveyStatus } from '@ps/survey-kernel';

@Injectable({ providedIn: 'root' })
export class BulkEditActionsFacade {
  private readonly _store = inject(Store);

  public setSelectedSurveys(selected: Survey[]): void {
    this._store.dispatch(BulkEditActions.setSelectedSurveys({ selected }));
  }

  public resetSelectedSurveys(): void {
    this._store.dispatch(BulkEditActions.resetSelectedSurveys());
  }

  public setSelectedBulkOperation(operation: BulkOperationType): void {
    this._store.dispatch(BulkEditActions.setBulkOperation({ operation }));
  }

  public bulkPatchValues(
    operation: BulkOperationType,
    operationLabel: string,
  ): void {
    this._store.dispatch(
      BulkEditActions.bulkPatchValues({ operation, operationLabel }),
    );
  }

  public launchTcReplica(operationLabel: string): void {
    this._store.dispatch(BulkEditActions.launchTcReplica({ operationLabel }));
  }

  public checkSurveysWithMatchingBillingID(billingId: string): void {
    this._store.dispatch(
      BulkEditActions.checkSurveysWithMatchingBillingID({
        billingId,
      }),
    );
  }

  public validateBillingID(billingId: string): void {
    this._store.dispatch(
      BulkEditActions.validateBillingID({
        billingId,
      }),
    );
  }

  public validateHighCpiOnStatusChange(status: SurveyStatus): void {
    this._store.dispatch(
      BulkEditActions.validateHighCpiOnStatusChange({
        status,
      }),
    );
  }

  public getSupplierSummaryReport(
    email: string,
    selectedSurveys: Survey[],
  ): void {
    this._store.dispatch(
      BulkEditActions.getSupplierSummaryReport({
        email,
        surveys: selectedSurveys,
      }),
    );
  }

  public groupSurveys(groupTitle: string, operationLabel: string): void {
    this._store.dispatch(
      BulkEditActions.groupSurveys({
        groupTitle,
        operationLabel,
      }),
    );
  }

  public deleteDraft(operationLabel: string): void {
    this._store.dispatch(BulkEditActions.deleteDraft({ operationLabel }));
  }
}
